import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";

import { ICompanyAccountingIntegrations } from "@/jenesys-types/jenesys-entities/config";

interface AccountingConnectionsProps {
  companyAccountingIntegrations: ICompanyAccountingIntegrations[];
}

export const AccountingConnections: React.FC<AccountingConnectionsProps> = ({
  companyAccountingIntegrations
}) => (
  <Accordion mt={12} defaultIndex={[0]} allowMultiple>
    <AccordionItem border={0}>
      <h2>
        <AccordionButton>
          <Box as="span" flex="1" textAlign="left">
            <Text fontWeight={600}>All users connected</Text>
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <Box>
          <TableContainer
            border="1px solid"
            borderColor="blackAlpha.300"
            rounded={6}
            pt={6}
            pb={6}
            px={8}
            mt={4}
            flexShrink={0}
          >
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th
                    pl={0}
                    color="black"
                    textTransform="capitalize"
                    fontWeight={600}
                  >
                    Name
                  </Th>
                  <Th color="black" textTransform="capitalize" fontWeight={600}>
                    Email
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {companyAccountingIntegrations?.map((integration: any) => (
                  <Tr key={integration.user.id}>
                    <Td pl={0} fontWeight={500} py={4}>
                      {integration.user.first_name} {integration.user.last_name}
                    </Td>
                    <Td fontWeight={500} py={4}>
                      {integration.user.email}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </AccordionPanel>
    </AccordionItem>
  </Accordion>
);
